import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark';

interface ThemeState {
  readonly theme: Theme;
  readonly setTheme: (theme: Theme) => void;
  readonly toggle: () => void;
}

/**
 * Light is the default everywhere — patient app and admin panel alike. The OS
 * preference is deliberately not consulted: dark mode is opt-in, chosen by the
 * patient or staff member, and only then persisted.
 */
const DEFAULT_THEME: Theme = 'light';

/**
 * Client state only — a preference, not server data, which is the one thing a
 * Zustand store is allowed to hold here (CLAUDE.md §7.3).
 */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: DEFAULT_THEME,
      setTheme: (theme: Theme): void => {
        set({ theme });
      },
      toggle: (): void => {
        set({ theme: get().theme === 'dark' ? 'light' : 'dark' });
      },
    }),
    { name: 'clinic.theme' },
  ),
);
